'use strict';

wbApp.controller('SemestersCtrl', ['$scope', '$modal', '$translate', '$filter', 'semesterSvc', 'securitySvc', 'tenantSettingSvc',
function ($scope, $modal, $translate, $filter, semesterSvc, securitySvc, tenantSettingSvc) {

    $scope.preferredBookingSupported = !tenantSettingSvc.settings.courseInterestsSupport &&
        !(tenantSettingSvc.settings.coursePreviewOnlyRegistration && !tenantSettingSvc.settings.allowClientCourseRegistration);


    function showCompensationTransferDetail(row) {
        compensationTransferDialogPromise.$promise.then(function () {
            compensationTransferDialogPromise.$scope.sourceSemesterID = row.id;
            compensationTransferDialogPromise.show();
        });
    }

    function showPreferredBookingDetail(row) {
        preferredBookingDialogPromise.$promise.then(function () {
            preferredBookingDialogPromise.$scope.semesterID = row.id;
            preferredBookingDialogPromise.$scope.onPreferredBookingSavedSuccessfully = function (model) {
                refreshData();
            }
            preferredBookingDialogPromise.show();
        });
    }

    $scope.rawSemesters = [];
    $scope.semesters = semesterSvc.getAllAsync();

    $scope.customFilter = { showInactive: false };

    function preFilter() {
        if (!$scope.rawSemesters.$promise) {
            return;
        }

        $scope.rawSemesters.$promise.then(function () {
            if ($scope.customFilter.showInactive) {
                $scope.semesters.length = 0;
                $scope.semesters.push.apply($scope.semesters, $scope.rawSemesters);
            } else {
                $scope.semesters.length = 0;
                $scope.semesters.push.apply($scope.semesters,
                    _.filter($scope.rawSemesters, { active: true }));
            }
        });
    }
    
    $scope.$watch('customFilter.showInactive', function (newValue, oldValue) {
        preFilter();
    }, true);



    $scope.gridSettings = {
        columns: [
            { dataField: 'isMain', caption: $translate.instant('TXT_MAIN'), dataType: 'boolean', width: '70px' },
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', width: '180px', sortOrder: 'asc' },
            { dataField: 'startDate', caption: $translate.instant('TXT_LBL_START_DATE'), dataType: 'date', width: '90px' },
            { dataField: 'endDate', caption: $translate.instant('TXT_LBL_END_DATE'), dataType: 'date', width: '90px' },
            { dataField: 'description', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string', sortOrder: 'asc' },
            { dataField: 'showInAttendance', caption: $translate.instant('TXT_LBL_SHOW_IN_ATTENDANCE'), dataType: 'boolean', width: '70px' },
            { dataField: 'openForRegistration', caption: $translate.instant('TXT_LBL_OPEN_FOR_REGISTRATION'), dataType: 'boolean', width: '70px' },
            {
                dataField: 'preferredBookingStartDate',
                caption: $translate.instant('TXT_MENU_PREFERRED_BOOKING'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return !!rowData.preferredBookingStartDate
                        ? ($filter('date')(rowData.preferredBookingStartDate, 'shortDate') + ' - ' + $filter('date')(rowData.preferredBookingEndDate, 'shortDate'))
                        : '';
                },
                width: '140px',
                visible: $scope.preferredBookingSupported
            },
        ],
        onCellPrepared: function (e) {
            if (e.rowType === "data" && e.columnIndex == 8) {               
                if (!!e.data.preferredBookingStartDate && !e.data.preferredBookingIsActive) {
                    e.cellElement.css('text-decoration', 'line-through');
                }
                if (!!e.data.preferredBookingEffectiveIsActive) {
                    e.cellElement.addClass('text-success');
                }
            }
        },
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                let data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.active === false) {
                    e.rowElement.addClass('text-muted');
                }
            }
        },
        customCommands: [{
            text: $translate.instant('TXT_MENU_TRANSFER_COMPENSATIONS'),
            isVisible: function (row) {
                return securitySvc.isInRole('Semester.CompensationTransfer');
            },
            callback: function (row) { showCompensationTransferDetail(row); }
        }, {
            text: $translate.instant('TXT_MENU_PREFERRED_BOOKING'),
            isVisible: function (row) {
                return $scope.preferredBookingSupported && securitySvc.isInRole('Semester.PreferredBooking');
            },
            callback: function (row) { showPreferredBookingDetail(row); }
        }]
    }
    
    function refreshData() {
        $scope.rawSemesters = semesterSvc.getAllAsync(true);
        preFilter();
    }

    $scope.$on('refreshData', function (e, data) {
        refreshData();
    });

    refreshData();


    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onSaved = function () {
                preFilter();
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = semesterSvc.newModel();
            detailDialogPromise.$scope.onSaved = function () {
                preFilter();
            };            
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        semesterSvc.remove(data).$promise.then(function () {
            preFilter();
        });
    }

    $scope.onRowSelected = function (data) {
        $scope.selectedSemester = data;
    }


    //$scope.tabs = [
    //{
    //    title: 'TXT_DETAIL',
    //    template: "finance/invoices/invoices-tabs/detail.html"
    //}];

    //$scope.tabs.activeTab = 0;


    var detailDialogPromise = $modal({
        templateUrl: 'setting/semesters/semesters-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var compensationTransferDialogPromise = $modal({
        templateUrl: 'setting/semesters/compensation-transfer-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var preferredBookingDialogPromise = $modal({
        templateUrl: 'setting/semesters/preferred-booking-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);
